import '../../assets/index50.css';var Co = Object.defineProperty, go = Object.defineProperties;
var bo = Object.getOwnPropertyDescriptors;
var L = Object.getOwnPropertySymbols;
var ao = Object.prototype.hasOwnProperty, io = Object.prototype.propertyIsEnumerable;
var eo = (o, e, r) => e in o ? Co(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, n = (o, e) => {
  for (var r in e || (e = {}))
    ao.call(e, r) && eo(o, r, e[r]);
  if (L)
    for (var r of L(e))
      io.call(e, r) && eo(o, r, e[r]);
  return o;
}, v = (o, e) => go(o, bo(e));
var N = (o, e) => {
  var r = {};
  for (var a in o)
    ao.call(o, a) && e.indexOf(a) < 0 && (r[a] = o[a]);
  if (o != null && L)
    for (var a of L(o))
      e.indexOf(a) < 0 && io.call(o, a) && (r[a] = o[a]);
  return r;
};
import { jsx as d, jsxs as Io } from "react/jsx-runtime";
import { createContext as wo, forwardRef as so, useContext as ko } from "react";
import { ErrorMessage as xo } from "../../molecules/ErrorMessage/index.js";
import { useForwardedRef as Go } from "../../hooks/useForwardedRef.js";
import { Label as Po } from "../Label/index.js";
import { e as K, c as E } from "../../get-size-Bc1Pz5yf.js";
import { c as M } from "../../create-vars-resolver-Bzbn9G-G.js";
import { f as D, u as F, B as j, p as no, h as V, e as Ao } from "../../factory-ueRxoNOV.js";
import { g as to } from "../../get-contrast-color-SC35uhiM.js";
import { g as co } from "../../get-auto-contrast-value-BGSSZ1GD.js";
import { u as W } from "../../use-styles-DToiHEa6.js";
import { I as No, a as So } from "../../InputsGroupFieldset-Bo-BOy1U.js";
import { u as zo } from "../../DirectionProvider-CT8S13Cp.js";
import { U as Bo } from "../../UnstyledButton-D9OCzDhz.js";
import { c as lo } from "../../create-optional-context-CQ2ahjKQ.js";
import { I as uo } from "../../Input--FNE961U.js";
import { u as mo } from "../../use-id-D2tGiO9x.js";
import { u as $o } from "../../use-uncontrolled-BT_j5D2R.js";
import { r as O } from "../../rem-CMQJ_ZTp.js";
import { F as Lo } from "../../Flex-BcSdq2bJ.js";
const [Eo, po] = lo(), [Vo, Do] = lo();
var fo = { card: "m_9dc8ae12" };
const Fo = {
  withBorder: !0
}, To = M((o, { radius: e }) => ({
  card: {
    "--card-radius": K(e)
  }
})), q = D((o, e) => {
  const r = F("RadioCard", Fo, o), C = r, {
    classNames: a,
    className: t,
    style: c,
    styles: s,
    unstyled: i,
    vars: l,
    checked: R,
    mod: x,
    withBorder: g,
    value: y,
    onClick: m,
    name: h,
    onKeyDown: b
  } = C, I = N(C, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "checked",
    "mod",
    "withBorder",
    "value",
    "onClick",
    "name",
    "onKeyDown"
  ]), B = W({
    name: "RadioCard",
    classes: fo,
    props: r,
    className: t,
    style: c,
    classNames: a,
    styles: s,
    unstyled: i,
    vars: l,
    varsResolver: To,
    rootSelector: "card"
  }), { dir: w } = zo(), p = po(), G = typeof R == "boolean" ? R : (p == null ? void 0 : p.value) === y || !1, P = h || (p == null ? void 0 : p.name), $ = (_) => {
    if (b == null || b(_), ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"].includes(_.nativeEvent.code)) {
      _.preventDefault();
      const f = Array.from(
        document.querySelectorAll(
          `[role="radio"][name="${P || "__mantine"}"]`
        )
      ), k = f.findIndex((T) => T === _.target), u = k + 1 >= f.length ? 0 : k + 1, A = k - 1 < 0 ? f.length - 1 : k - 1;
      _.nativeEvent.code === "ArrowDown" && (f[u].focus(), f[u].click()), _.nativeEvent.code === "ArrowUp" && (f[A].focus(), f[A].click()), _.nativeEvent.code === "ArrowLeft" && (f[w === "ltr" ? A : u].focus(), f[w === "ltr" ? A : u].click()), _.nativeEvent.code === "ArrowRight" && (f[w === "ltr" ? u : A].focus(), f[w === "ltr" ? u : A].click());
    }
  };
  return /* @__PURE__ */ d(Vo, { value: { checked: G }, children: /* @__PURE__ */ d(
    Bo,
    v(n(n({
      ref: e,
      mod: [{ "with-border": g, checked: G }, x]
    }, B("card")), I), {
      role: "radio",
      "aria-checked": G,
      name: P,
      onClick: (_) => {
        m == null || m(_), p == null || p.onChange(y || "");
      },
      onKeyDown: $
    })
  ) });
});
q.displayName = "@mantine/core/RadioCard";
q.classes = fo;
const Uo = {}, H = D((o, e) => {
  const b = F("RadioGroup", Uo, o), { value: r, defaultValue: a, onChange: t, size: c, wrapperProps: s, children: i, name: l, readOnly: R } = b, x = N(b, ["value", "defaultValue", "onChange", "size", "wrapperProps", "children", "name", "readOnly"]), g = mo(l), [y, m] = $o({
    value: r,
    defaultValue: a,
    finalValue: "",
    onChange: t
  });
  return /* @__PURE__ */ d(Eo, { value: { value: y, onChange: (I) => !R && m(typeof I == "string" ? I : I.currentTarget.value), size: c, name: g }, children: /* @__PURE__ */ d(
    uo.Wrapper,
    v(n(n({
      size: c,
      ref: e
    }, s), x), {
      labelElement: "div",
      __staticSelector: "RadioGroup",
      children: /* @__PURE__ */ d(No, { role: "radiogroup", children: i })
    })
  ) });
});
H.classes = uo.Wrapper.classes;
H.displayName = "@mantine/core/RadioGroup";
function vo(a) {
  var t = a, { size: o, style: e } = t, r = N(t, ["size", "style"]);
  return /* @__PURE__ */ d(
    "svg",
    v(n({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 5 5",
      style: n({ width: O(o), height: O(o) }, e),
      "aria-hidden": !0
    }, r), {
      children: /* @__PURE__ */ d("circle", { cx: "2.5", cy: "2.5", r: "2.5", fill: "currentColor" })
    })
  );
}
var _o = { indicator: "m_717d7ff6", icon: "m_3e4da632", "indicator--outline": "m_2980836c" };
const jo = {
  icon: vo
}, Oo = M(
  (o, { radius: e, color: r, size: a, iconColor: t, variant: c, autoContrast: s }) => {
    const i = no({ color: r || o.primaryColor, theme: o }), l = i.isThemeColor && i.shade === void 0 ? `var(--mantine-color-${i.color}-outline)` : i.color;
    return {
      indicator: {
        "--radio-size": E(a, "radio-size"),
        "--radio-radius": e === void 0 ? void 0 : K(e),
        "--radio-color": c === "outline" ? l : V(r, o),
        "--radio-icon-size": E(a, "radio-icon-size"),
        "--radio-icon-color": t ? V(t, o) : co(s, o) ? to({ color: r, theme: o, autoContrast: s }) : void 0
      }
    };
  }
), Y = D((o, e) => {
  const r = F("RadioIndicator", jo, o), C = r, {
    classNames: a,
    className: t,
    style: c,
    styles: s,
    unstyled: i,
    vars: l,
    icon: R,
    radius: x,
    color: g,
    iconColor: y,
    autoContrast: m,
    checked: h,
    mod: b,
    variant: I,
    disabled: B
  } = C, w = N(C, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "icon",
    "radius",
    "color",
    "iconColor",
    "autoContrast",
    "checked",
    "mod",
    "variant",
    "disabled"
  ]), p = R, G = W({
    name: "RadioIndicator",
    classes: _o,
    props: r,
    className: t,
    style: c,
    classNames: a,
    styles: s,
    unstyled: i,
    vars: l,
    varsResolver: Oo,
    rootSelector: "indicator"
  }), P = Do(), $ = typeof h == "boolean" ? h : (P == null ? void 0 : P.checked) || !1;
  return /* @__PURE__ */ d(
    j,
    v(n(v(n({
      ref: e
    }, G("indicator", { variant: I })), {
      variant: I,
      mod: [{ checked: $, disabled: B }, b]
    }), w), {
      children: /* @__PURE__ */ d(p, n({}, G("icon")))
    })
  );
});
Y.displayName = "@mantine/core/RadioIndicator";
Y.classes = _o;
var ho = { root: "m_f3f1af94", inner: "m_89c4f5e4", icon: "m_f3ed6b2b", radio: "m_8a3dbb89", "radio--outline": "m_1bfe9d39" };
const Ko = {
  labelPosition: "right"
}, Mo = M(
  (o, { size: e, radius: r, color: a, iconColor: t, variant: c, autoContrast: s }) => {
    const i = no({ color: a || o.primaryColor, theme: o }), l = i.isThemeColor && i.shade === void 0 ? `var(--mantine-color-${i.color}-outline)` : i.color;
    return {
      root: {
        "--radio-size": E(e, "radio-size"),
        "--radio-radius": r === void 0 ? void 0 : K(r),
        "--radio-color": c === "outline" ? l : V(a, o),
        "--radio-icon-color": t ? V(t, o) : co(s, o) ? to({ color: a, theme: o, autoContrast: s }) : void 0,
        "--radio-icon-size": E(e, "radio-icon-size")
      }
    };
  }
), z = D((o, e) => {
  var X, oo;
  const r = F("Radio", Ko, o), Q = r, {
    classNames: a,
    className: t,
    style: c,
    styles: s,
    unstyled: i,
    vars: l,
    id: R,
    size: x,
    label: g,
    labelPosition: y,
    description: m,
    error: h,
    radius: b,
    color: I,
    variant: B,
    disabled: w,
    wrapperProps: p,
    icon: G = vo,
    rootRef: P,
    iconColor: $,
    onChange: C,
    mod: _
  } = Q, f = N(Q, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "id",
    "size",
    "label",
    "labelPosition",
    "description",
    "error",
    "radius",
    "color",
    "variant",
    "disabled",
    "wrapperProps",
    "icon",
    "rootRef",
    "iconColor",
    "onChange",
    "mod"
  ]), k = W({
    name: "Radio",
    classes: ho,
    props: r,
    className: t,
    style: c,
    classNames: a,
    styles: s,
    unstyled: i,
    vars: l,
    varsResolver: Mo
  }), u = po(), A = (X = u == null ? void 0 : u.size) != null ? X : x, T = r.size ? x : A, { styleProps: yo, rest: U } = Ao(f), Z = mo(R), J = u ? {
    checked: u.value === U.value,
    name: (oo = U.name) != null ? oo : u.name,
    onChange: (ro) => {
      u.onChange(ro), C == null || C(ro);
    }
  } : {};
  return /* @__PURE__ */ d(
    So,
    v(n(n(v(n({}, k("root")), {
      __staticSelector: "Radio",
      __stylesApiProps: r,
      id: Z,
      size: T,
      labelPosition: y,
      label: g,
      description: m,
      error: h,
      disabled: w,
      classNames: a,
      styles: s,
      unstyled: i,
      "data-checked": J.checked || void 0,
      variant: B,
      ref: P,
      mod: _
    }), yo), p), {
      children: /* @__PURE__ */ Io(j, v(n({}, k("inner")), { mod: { "label-position": y }, children: [
        /* @__PURE__ */ d(
          j,
          v(n(n(v(n({}, k("radio", { focusable: !0, variant: B })), {
            onChange: C
          }), U), J), {
            component: "input",
            mod: { error: !!h },
            ref: e,
            id: Z,
            disabled: w,
            type: "radio"
          })
        ),
        /* @__PURE__ */ d(G, v(n({}, k("icon")), { "aria-hidden": !0 }))
      ] }))
    })
  );
});
z.classes = ho;
z.displayName = "@mantine/core/Radio";
z.Group = H;
z.Card = q;
z.Indicator = Y;
const Wo = "Radio-module__radioGroupLabel___A7yIY", qo = "Radio-module__radio___dpBlV", Ho = "Radio-module__radioIcon___ynpHz", Yo = "Radio-module__radioInner___bZRFE", Zo = "Radio-module__radioBody___i-NSh", Jo = "Radio-module__radioLabel___VxVM0", S = {
  radioGroupLabel: Wo,
  radio: qo,
  radioIcon: Ho,
  radioInner: Yo,
  radioBody: Zo,
  radioLabel: Jo
}, Ro = wo({}), Qo = so((x, R) => {
  var g = x, {
    clearable: o = !1,
    error: e,
    horizontal: r,
    onChange: a,
    value: t,
    label: c,
    required: s,
    className: i
  } = g, l = N(g, [
    "clearable",
    "error",
    "horizontal",
    "onChange",
    "value",
    "label",
    "required",
    "className"
  ]);
  const y = (m) => {
    if (!m.current)
      return;
    const h = m.current.checked;
    m.current.checked = !h, a(h ? null : m.current.value);
  };
  return /* @__PURE__ */ d(
    z.Group,
    v(n({
      "aria-invalid": !!e,
      classNames: {
        label: S.radioGroupLabel,
        root: S.radioGroupRoot
      },
      error: e && /* @__PURE__ */ d(xo, { error: e }),
      onChange: a,
      ref: R,
      value: t,
      label: typeof c == "string" ? /* @__PURE__ */ d(Po, { label: c, withAsterisk: s }) : c
    }, l), {
      children: /* @__PURE__ */ d(Ro.Provider, { value: o && { onClick: y } || {}, children: /* @__PURE__ */ d(Lo, { direction: r ? "row" : "column", gap: O(r ? 24 : 8), children: l.children }) })
    })
  );
}), Xo = so((t, a) => {
  var c = t, { label: o, disabled: e } = c, r = N(c, ["label", "disabled"]);
  const { onClick: s } = ko(Ro), i = Go(a);
  return /* @__PURE__ */ d(
    z,
    n({
      classNames: {
        body: S.radioBody,
        icon: S.radioIcon,
        inner: S.radioInner,
        label: S.radioLabel,
        radio: S.radio
      },
      disabled: e,
      label: o,
      onClick: s && (() => s(i)),
      onKeyDown: (l) => {
        i.current && l.key === " " && (l.preventDefault(), s && s(i));
      },
      ref: i,
      variant: "outline"
    }, r)
  );
}), gr = Object.assign({}, Xo, {
  Group: Qo
});
export {
  gr as Radio
};
